import { Injectable } from '@angular/core';

type AnalyticsPayload = {
  event: string;
  event_category?: string;
  event_label?: string;
  event_description?: string;
};

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  trackEvent(
    eventName: string,
    eventLabel: string,
    eventCategory: string,
    eventDescription?: string
  ) {
    const dataLayer = ((window as any).dataLayer =
      (window as any).dataLayer || []);

    const payload: AnalyticsPayload = {
      event: eventName,
      event_category: eventCategory,
      event_label: eventLabel,
    };

    if (eventDescription) {
      payload.event_description = eventDescription;
    }

    dataLayer.push(payload);
  }
}
